import {Component, Input} from '@angular/core';
import {AdminDashboardRenewalEvent} from '@features/admin-panel/models/admin-dashboard-c360-commercial.models';
import {adbUsdCompact, adbUsdFull} from '@features/admin-panel/helpers/admin-dashboard-format';

/** Outcome pill tone: Renewed green, Started blue, Did not renew red, Due amber; anything else neutral. */
const OUTCOME_TONE: {[outcome: string]: string} = {Renewed: 'green', Started: 'blue', 'Did not renew': 'red', Due: 'amber'};

/**
 * Company 360 "Renewal history" (ITP-E-167-05; OCA-E-159 M/company/[id]/page.tsx:535-566): the rows of
 * `AdminDashboardCompanyCommercialQuery`'s `RenewalHistory` (ITP-E-167-01, Plan ITP-P-35 Q12), newest first, as
 * Date | Outcome | ARR | Change. Rendered by the Commercial part beside the Transactions card.
 */
@Component({
  standalone: false,
  selector: 'app-admin-dashboard-c360-renewal-history',
  templateUrl: './admin-dashboard-c360-renewal-history.component.html',
  styleUrls: ['./admin-dashboard-c360-renewal-history.component.scss']
})
export class AdminDashboardC360RenewalHistoryComponent {
  /** The rows, newest first. */
  @Input() history: AdminDashboardRenewalEvent[] = [];
  /** False for a company without a Client Manager record: its ARR and changes are unknown. */
  @Input() hasRecord = true;

  /** The outcome pill's tone (`data-tone`), see OUTCOME_TONE. */
  outcomeTone(outcome: string): string {
    return OUTCOME_TONE[outcome] ?? 'neutral';
  }

  /** "$24,000" (adbUsdFull), or "Unknown" without a Client Manager record or an ARR. */
  arrText(event: AdminDashboardRenewalEvent): string {
    return this.known(event) ? adbUsdFull(event.arr) : 'Unknown';
  }

  /** "+$4.0k" / "−$3.5k" (U+2212 minus, adbUsdCompact), or "–" (en dash) for Due and when unknown. */
  changeText(event: AdminDashboardRenewalEvent): string {
    if (event.outcome === 'Due' || !this.known(event) || event.change === null || event.change === undefined) {
      return '–';
    }
    return `${event.change >= 0 ? '+' : '−'}${adbUsdCompact(Math.abs(event.change))}`;
  }

  private known(event: AdminDashboardRenewalEvent): boolean {
    return this.hasRecord && event.arr !== null && event.arr !== undefined;
  }
}
